module.exports = __webpack_public_path__ + "static/video-poster-fdcd562fcd8115dab560e3a9e964d8c9.png";